module.exports = __webpack_public_path__ + "img/mobile-catch-flow.2019a4d4.svg";